import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mainbody modulewrap"
};
const _hoisted_2 = {
  class: "mbwhite"
};
const _hoisted_3 = {
  class: "homebody realwrap homeabout"
};
const _hoisted_4 = {
  class: "mtitle"
};
const _hoisted_5 = {
  class: "word"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, null, -1);
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  class: "mmore"
};
const _hoisted_9 = {
  class: "mbgray"
};
const _hoisted_10 = {
  class: "homebody realwrap"
};
const _hoisted_11 = {
  class: "mtitle"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, null, -1);
const _hoisted_13 = {
  class: "mconcourse"
};
const _hoisted_14 = {
  class: "courseitem"
};
const _hoisted_15 = {
  class: "mtitle2"
};
const _hoisted_16 = {
  class: "word"
};
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, null, -1);
const _hoisted_18 = {
  class: "mmore2"
};
const _hoisted_19 = {
  class: "mbwhite"
};
const _hoisted_20 = {
  class: "homebody realwrap"
};
const _hoisted_21 = {
  class: "mtitle"
};
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, null, -1);
const _hoisted_23 = {
  class: "mconnews"
};
const _hoisted_24 = {
  class: "newsimg"
};
const _hoisted_25 = {
  class: "newsbox"
};
const _hoisted_26 = {
  class: "mmore3"
};
const _hoisted_27 = {
  class: "mbwhite"
};
const _hoisted_28 = {
  class: "homebody"
};
const _hoisted_29 = {
  class: "mtitle"
};
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, null, -1);
const _hoisted_31 = {
  class: "mconpartner"
};
import { FFmixin } from "@/mixin/mixin.js";
export default {
  __name: 'home',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const FFdata = reactive({
      isLoad: false,
      dataAbout: {},
      listCourse: [],
      listNews: [],
      listPartner: []
    });
    const getData = () => {
      FFmixin().setTitle(1, 0, 0, () => {
        proxy.$common.fetch({
          'act': 'telfort_home',
          msg: ''
        }, res => {
          proxy.$common.each(res.infodatacoursekind, item => {
            item.x_children = proxy.$common.basic.FFfilter(res.infodatacourse, 'navkv', item.kv);
          });
          FFdata.dataAbout = res.infodata;
          FFdata.listCourse = res.infodatacoursekind;
          FFdata.listNews = res.infodatanews;
          FFdata.listPartner = res.infodatapartner;
          FFdata.isLoad = true;
        });
      });
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_fftitle = _resolveComponent("fftitle");
      const _component_fflink = _resolveComponent("fflink");
      const _component_ffimg = _resolveComponent("ffimg");
      const _component_ffswiper2 = _resolveComponent("ffswiper2");
      return _unref(FFdata).isLoad ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$common.langInfo(_unref(FFdata).dataAbout.title, _unref(FFdata).dataAbout.title_en)), 1), _hoisted_6]), _createElementVNode("div", {
        class: "mconabout editor",
        innerHTML: _ctx.$common.langInfo(_unref(FFdata).dataAbout.content, _unref(FFdata).dataAbout.content_en)
      }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, [_createVNode(_component_router_link, {
        to: "/about"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$common.dicWord('more')), 1)]),
        _: 1
      })])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_fftitle, {
        alias: "home_title_course"
      }), _hoisted_12]), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).listCourse, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "courseitembox",
          key: item.id,
          style: _normalizeStyle({
            backgroundImage: 'url(' + item.cover + ')'
          })
        }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$common.langInfo(item.title, item.title_en)), 1), _hoisted_17]), _createElementVNode("dl", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.x_children, item2 => {
          return _openBlock(), _createElementBlock("dd", null, [_createVNode(_component_fflink, {
            info: item2,
            root: "/course"
          }, null, 8, ["info"])]);
        }), 256))]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_router_link, {
          to: "/course"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$common.dicWord('more')), 1)]),
          _: 1
        })])])], 4);
      }), 128))])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_fftitle, {
        alias: "home_title_news"
      }), _hoisted_22]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_ffimg, {
        alias: "telfort_homenews"
      })]), _createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).listNews, item => {
        return _openBlock(), _createElementBlock("dl", {
          key: item.id
        }, [_createElementVNode("dt", null, [_createVNode(_component_fflink, {
          info: item,
          root: "/news"
        }, null, 8, ["info"])]), _createElementVNode("dd", null, _toDisplayString(_ctx.$common.basic.dateFormat(item.publishdate)), 1)]);
      }), 128)), _createElementVNode("div", _hoisted_26, [_createVNode(_component_router_link, {
        to: "/news"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$common.dicWord('more')), 1)]),
        _: 1
      })])])])])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(_component_fftitle, {
        alias: "home_title_partner"
      }), _hoisted_30]), _createElementVNode("div", _hoisted_31, [_createVNode(_component_ffswiper2, {
        infoList: _unref(FFdata).listPartner
      }, null, 8, ["infoList"])])])])])) : _createCommentVNode("", true);
    };
  }
};